import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=2d22e418&scoped=true&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyField.vue?vue&type=style&index=0&id=2d22e418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22e418",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ReadOnlyField.vue
// module id = 1584
// module chunks = 0